import React, { useMemo } from "react";
import format from "date-fns/format";

import TableCell from "components/Tables/TableCell";
import { FORMAT_DATE_WITH_TIME } from "constants/time";
import { formatShortAddress } from "helpers/address";

import styles from "./styles.module.scss";

const RoutesTableData = ({ content = {} }) => {
    const route = content.loading_address || content.unloading_address;

    const formattedTitle = useMemo(() => {
        return formatShortAddress(route);
    }, [route]);

    const date = useMemo(() => {
        if (content.loading_from) {
            return format(new Date(content.loading_from), FORMAT_DATE_WITH_TIME);
        } else if (content.unloading_from) {
            return format(new Date(content.unloading_from), FORMAT_DATE_WITH_TIME);
        }
        return "";
    }, [content.loading_from, content.unloading_from]);

    return (
        <TableCell
            icon={<span className={`${styles.flag} fi fi-${route?.country_code?.toLowerCase()}`} />}
            title={formattedTitle}
            description={date && <div className={`${styles.date} ${content.isExpired ? styles.expired : ''}`}>{date}</div>}
        />
    );
};

export default RoutesTableData;
